import { CalculateVenueEss } from '@/domain/impact-calculate-venue/entities/calculate-venue-ess.entity';

/**
 * For some reason the computation of the parity score was wrong in the PDF generation,
 * @see with Maxime how to fix this in the app if needed.
 */
export const extendVenueEssCalculate = (initialState: CalculateVenueEss) => {
  // workaround to avoid the readonly Redux state
  const ess = JSON.parse(JSON.stringify(initialState)) as CalculateVenueEss;
  ess.structure.topics.PARITY_EQUALITY.score =
    ess.structure.topics.PARITY_EQUALITY.score + (ess.dates.score || 0);
  ess.structure.topics.PARITY_EQUALITY.maxScore =
    ess.structure.topics.PARITY_EQUALITY.maxScore + (ess.dates.maxScore || 0);
  return ess;
};
